<template>
  <div class="box">
    <div class="main2 flex-col">
      <div class="section1 flex-row">
        <span class="word">实物名称</span>
        <span class="word">订单号</span>
        <span class="word">到达时间</span>
        <span class="word">在库状态</span>
        <span class="word">剩余量</span>
      </div>
    </div>
    <div v-for="(customerMaterial,index) in customerMaterialInfo">
      <div class="main3 flex-col">
        <div class="line"></div>
        <div class="mod3 flex-row">
          <span class="txt">{{ customerMaterial.receiveWareName }}</span>
          <span class="txt" style="white-space: nowrap;" v-if="customerMaterial.orderNo !== undefined">{{ customerMaterial.orderNo }}</span>
          <span class="txt" style="white-space: nowrap;" v-else></span>
          <span class="txt middle-fixed-width">{{ customerMaterial.receiveDT }}</span>
          <span class="txt samll-fixed-width">{{ customerMaterial.statusName }}</span>
          <span class="txt samll-fixed-width">{{ customerMaterial.goodsQuantity }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {mapState} from 'vuex'
  export default {
    name: 'MaterialInquire',
    created () {
      this.getData()
    },
    computed: {
      ...mapState([
        'sessionInfo'
      ])
    },
    data () {
      return {
        customerMaterialInfo: []
      }
    },
    methods: {
      getData () {
        let _this = this
        let customerNo = this.sessionInfo.customerInfo.customerNo
        this.$weui.loading('加载中')
        _this.gcapi('loadCustomerMaterialInfoInStock', customerNo).then((response) => {
          this.customerMaterialInfo = JSON.parse(response.body.result)
          this.$weui.loading('加载中').hide()
        })
      }
    }
  }
</script>

<style scoped>
  .box {
    overflow-y:scroll;
    overflow-x:hidden;
    width: 100%;
    height: 100vh;
    position: absolute;
    padding-bottom: 0;
    background-color: #fafafa;
  }

  .main2 {
    height: 51px;
    width: 100%;
    justify-content: center;
    align-items: flex-end;
    padding-right: 5px;
    position: absolute;
    background: #FFFFFF;
  }

  .section1 {
    width: 100%;
    /*height: 20px;*/
  }

  .word {
    width: 100%;
    /*height: 20px;*/
    display: block;
    overflow-wrap: break-word;
    color: rgba(66, 66, 66, 1);
    font-size: 14px;
    font-family: PingFangSC-Medium;
    line-height: 20px;
    text-align: left;
    margin-left: 15px;
  }

  .main3 {
    height: 50px;
    width: 100%;
    justify-content: center;
    align-items: flex-start;
    padding-left: 15px;
    position: relative;
    left: 0;
    top: 50px;
    background: #FFFFFF;
  }

  .mod3 {
    width: 100%;
    height: 20px;
    margin-top: 15px;
    margin-left: 15px;
  }

  .txt {
    width: 15%;
    height: 20px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(66, 66, 66, 1);
    font-size: 14px;
    line-height: 20px;
    text-align: left;
    margin-right: 15px;
  }

  .middle-fixed-width {
    width: 77px;
    white-space: nowrap;
  }

  .samll-fixed-width {
    width: 56px;
    white-space: nowrap;
  }

  .line {
    width: 100%;
    height: 1px;
    background: #EFEEF3;
    margin-top: -30px;
  }
</style>



// WEBPACK FOOTER //
// MaterialInquire.vue?312d17e4